import { router } from '@inertiajs/vue3'

let stale = false

const reloadPageOnNavigate = () => {
  window.addEventListener('popstate', () => {
    stale = true
  })

  router.on('navigate', (event) => {
    const page = event.detail.page
    if (stale) {
      console.log('stale')
      router.get(
        page.url,
        {},
        { replace: true, preserveState: true, preserveScroll: true }
      )
    }
    stale = false
  })
}

export { reloadPageOnNavigate, stale }
